import React, { useEffect, useState } from "react";
import { FolderListComponent } from "./Component/FolderList";
import ViewFileRepositoryList from "./Component/ViewFileRepositoryList";
import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useMediaQuery, useTheme } from "@mui/material";
import { FileRepositoryProvider } from "./FileRepositoryContext";
import { FolderList } from "./modal";
import { useFileRepository } from "./FileRepositoryContext";



export const FileRepository = () => {
  return (
    <FileRepositoryProvider>
      <FileRepositoryContent />
    </FileRepositoryProvider>
  )
}

const FileRepositoryContent = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));


  return (

    <Container sx={{ p: 1, height: "100%", width: "100%" }}  >

      <Grid container columnSpacing={2} rowSpacing={isSmallScreen ? 3 : 0} direction={isSmallScreen ? "column" : "row"} >
        <Grid height="85vh" xs={isSmallScreen ? 12 : 5} >
          <FolderListComponent />
        </Grid>
        <Grid height="85vh" xs={isSmallScreen ? 12 : 7} >
          <ViewFileRepositoryList />
        </Grid>
      </Grid>

    </Container >

  )
}